// extracted by mini-css-extract-plugin
export default {"path":"path_path__QcQj2"};